/*
 * Copyright (c) 2026 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Sunday, May 17th 2026, 10:41:24 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */
/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Thursday, July 7th 2022, 9:34:26 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { isEmpty } from "lodash";
import { getDefaultSubprocessConfigForCallActivity } from "lib/factories";
import { TaskTemplate } from "lib/schemas";
import { DownstreamProcessConfigurationModalForm } from "service-builder/components/workflow-builder/DownstreamProcessConfigurationMany2ManyPicker";
import { useDownstreamProcessConfigurationAPIForm } from "service-builder/services";
import { AutoSaveFormProvider, useOSFormContext } from "ui-widgets/forms/providers";
import { InputHelpDialogWrapper } from "ui-widgets";

export const CalledElementSettings = () => {
  const { watch, setValue } = useOSFormContext<TaskTemplate>();
  const defaultConfig = getDefaultSubprocessConfigForCallActivity(watch());

  const useAPIFormReturn = useDownstreamProcessConfigurationAPIForm({
    downstreamProcessConfiguration: defaultConfig,
    onUpdateDownstreamProcessConfiguration: (config) => {
      setValue("downstream_process_configurations", [config.id]);
    },
    apiInitialFetchId: watch("downstream_process_configurations")?.[0],
  });

  return (
    <>
      <InputHelpDialogWrapper
        helpTitle="Called Element"
        helpContent={<>Provide configuration details for the subprocess to be invoked for this call activity.</>}
      >
        <AutoSaveFormProvider
          isNewData
          submitFunction={() => {
            if (isEmpty(useAPIFormReturn.useFormReturn.formState.dirtyFields)) return;
            useAPIFormReturn.submitAPIForm();
          }}
          useFormReturn={useAPIFormReturn.useFormReturn}
        >
          <DownstreamProcessConfigurationModalForm
            useAPIFormReturn={useAPIFormReturn}
            showSubmitButton={false}
            downstreamProcessLabel="Subprocess"
          />
        </AutoSaveFormProvider>
      </InputHelpDialogWrapper>
    </>
  );
};
